import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import unsplash from "../api/unsplash";
import { DataGrid, GridToolbar, itIT } from '@mui/x-data-grid';
import {IconButton,Button,TextField,Dialog,DialogActions,DialogContent,DialogContentText,DialogTitle,Grid} from '@mui/material';
import '../style/style.css';
import {Edit,Delete,Add} from '@mui/icons-material';

let newSede = {Descrizione:"",Blocco:"",Referente:"",UnitaProduttiva:"",Ubicazione:""};
const Sedi = (props) =>{
const [sedi,setSedi] = useState();
const [sedeEdit,setSedeEdit] = useState();
const columns = [
  

    { field: 'Descrizione', headerName: 'Sede', width: 200 },
    { field: 'Blocco', headerName: 'Blocco', width: 200 },
    { field: 'Referente', headerName: 'Referente', width: 200 },
    { field: 'ID', headerName: '', hide: true, width :"130"},
    { field: "UnitaProduttiva", headerName: 'Unità produttiva', hide: false, width :"200"},
    { field: "Ubicazione", headerName: 'Ubicazione', hide: false, width :"200"},
    { field: "Azioni", headerName: 'Azioni', hide: false, width :"200",
    renderCell: (params) => ( //mi aiuta a mettere il valore
    <>
    <IconButton aria-label="edit">
    <Edit 
    style={{height:"2rem",width:"2rem",color:"#2264ae"}}
   onClick= {async() => {await setSedeEdit({ID:params.row.ID,Descrizione:params.row.Descrizione,Blocco:params.row.Blocco,Referente:params.row.Referente,UnitaProduttiva:params.row.UnitaProduttiva,Ubicazione:params.row.Ubicazione});document.getElementById("edit").click();}}
      />
  </IconButton>
 <DeleteDialog id={params.row.ID} blocco={params.row.Blocco} sede={params.row.Descrizione} myFunction={deleteSede}/>
  </>
  
    )
  }
  ];
  



useEffect( () => {

  async function fetchData() {
        let responseSedi =  await unsplash
          .get('sedi',{ headers: {
            'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
          },params:{id:props.idAzienda}}
           );
     
           console.log(responseSedi.data);
           setSedi(responseSedi.data.data);
        }
        fetchData();
},[]);


const handleSaveData= async(sede,operazione) =>{

  try{
    if(operazione === "Inserimento"){
  
     
        //inserisco il nuovo
      try{
        let response = await unsplash.post('sedi',{cliente:props.idAzienda,sede:sede},
        { headers: {
          'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
        }}  );
      
       
       let responseSedi =  await unsplash
          .get('sedi',{ headers: {
            'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
          },params:{id:props.idAzienda}}
           );
     

           setSedi(responseSedi.data.data);
           alert("inserimento effettuato")
        }catch{
          console.log("ERRORE DURANTE L'INSERIMENTO")
        }
    }

    if(operazione === "Modifica"){
  
      
        //inserisco il nuovo
        try{
        let responseModifica = await unsplash.put('sedi',{cliente:props.idAzienda,sede:sede},
        { headers: {
          'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
        }}  );
        alert("modifica effettuata")
        }catch{
          console.log("ERRORE DURANTE LA MODIFICA")
        }
       
      
     
    }

    let responseSedi =  await unsplash
    .get('sedi',{ headers: {
      'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
    },params:{id:props.idAzienda}}
     );


     setSedi(responseSedi.data.data);
   


  }catch(error){
    console.log(error)
  }

}

const deleteSede = async(id) => {
  try {
    await unsplash
   .delete('sedi',
   { headers: {
     'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
   },
     data: {
       id: id
     
   }
 });
 
 
 let responseSedi =  await unsplash
     .get('sedi',{ headers: {
       'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
     },params:{id:props.idAzienda}}
      );
 
 
      setSedi(responseSedi.data.data);
 
 
 }catch(error){
   console.log(error);
 }
 
 }



    return <div>


 {
sedi === undefined?
"":
<>  <IconButton aria-label="edit">
    <Add 
    style={{height:"2rem",width:"2rem",color:"#2264ae"}}
    onClick= {() => document.getElementById("add").click()}
      />
  </IconButton>
  <FormDialog id="edit" operazione="Modifica" sede={sedeEdit} saveFunction={handleSaveData}/>
  <FormDialog id="add" operazione="Inserimento" sede={newSede} saveFunction={handleSaveData}/>
<div style={{ height: 400, width: '100%' }} >
<DataGrid
    components={{ Toolbar: GridToolbar }}
      localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
      rows={sedi}
      getRowId={sedi => sedi.ID}
      columns={columns}
      disableSelectionOnClick
    />
    </div>
    </>
 }
    </div>

}

export default Sedi





const FormDialog = (props) => {
    const [open, setOpen] = useState(false);
    const [sede, setSede] = useState({Descrizione:"",Blocco:"",Referente:"",UnitaProduttiva:"",Ubicazione:""});
    const [validation,setValidation]=useState(false);
    const handleClickOpen = () => {
      setValidation(false);
         setSede(props.sede);
      setOpen(true);
    };
  
    const handleClose = () => {
        setSede(newSede);
    
      setOpen(false);
    };
  const handleChange = (e)=> {

let s = {...sede};
s[e.target.name]=e.target.value;
setSede(s);
  }

const handleSave = () => {
if(sede.Blocco ==="" || sede.Blocco ===null){
  setValidation(true);
  }else{

props.saveFunction(sede,props.operazione);
}

}



    return (
      <div>
        <Button variant="outlined" onClick={handleClickOpen} id={props.id} style={{display:"None"}} >
          Open form dialog
        </Button>
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>{props.operazione}</DialogTitle>
          <DialogContent>
              <Grid container xs={12} spacing={2}>
              <Grid item xs={6}>
        <TextField
              value={sede.Descrizione}
              margin="dense"
              name="Descrizione"
              label="Sede"
              type="text"
              fullWidth
              variant="outlined"
              onChange={handleChange}
            />
</Grid>
<Grid item xs={6}>
        <TextField
         error={validation}
         value={sede.Blocco}
              margin="dense"
              name="Blocco"
              label="Blocco"
              type="text"
              required
              fullWidth
              variant="outlined"
              onChange={handleChange}
              helperText={validation?"Blocco obbligatorio":""}
            />
</Grid>
<Grid item xs={6}>
        <TextField
              value={sede.Ubicazione}
              margin="dense"
              name="Ubicazione"
              label="Ubicazione"
              type="text"
              fullWidth
              variant="outlined"
              onChange={handleChange}
     />
</Grid>
<Grid item xs={6}>
        <TextField
          value={sede.UnitaProduttiva}
              margin="dense"
              name="UnitaProduttiva"
              label="Unita Produttiva"
              type="text"
              fullWidth
              variant="outlined"
              onChange={handleChange}
            />
</Grid>
<Grid item xs={12}>
        <TextField
          value={sede.Referente}
              margin="dense"
              name="Referente"
              label="Referente"
              type="text"
              fullWidth
              variant="outlined"
              onChange={handleChange}
            />
</Grid>
</Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Chiudi</Button>
            <Button onClick={handleSave}>Salva</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

const  DeleteDialog =(props)=> {
    const [open, setOpen] = React.useState(false);
  
    const handleClickOpen = () => {
      setOpen(true);
    };
  
    const handleClose = () => {
      setOpen(false);
    };

    
    return (
      <div>
         <IconButton aria-label="edit" onClick={handleClickOpen}>
    <Delete 
     style={{height:"2rem",width:"2rem",color:"red"}}
        />
    </IconButton>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
           Sei sicuro di voler eliminare la sede selezionata?
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
            Attenzione, sei sicuro di voler eliminare la seguente sede ?<br/>
            {props.sede + " - " +props.blocco}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>annulla</Button>
            <Button onClick={() => props.myFunction(props.id)} autoFocus>
              Conferma
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }